module.exports = __webpack_public_path__ + "img/super-bundle-36.08107c9.webp";